import React, { useEffect, useState } from 'react';
import { FadeLoader } from 'react-spinners';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getSession } from 'utils/general';
import { fetchOnBoardData } from 'api/onBoarding';
import { styledTheme } from 'globalStyles/theme';
import AccountSetUpHero from 'assets/images/account_setup.jpg';
import './styles.scss';

const AccountSetupStarted = () => {
  const history = useHistory();
  const sessionInfo = getSession();
  const userInfo = useSelector((state) => state.global.userInfo);
  const [username, setUsername] = useState(userInfo?.firstName || '');
  const [firstName, setFirstName] = useState('');

  useEffect(() => {
    async function fetchBoardingData() {
      const boardingData = await fetchOnBoardData();
      if (boardingData) {
        setFirstName(boardingData.login?.firstname || '');
        setUsername(boardingData.login?.username || '');
      }
    }
    fetchBoardingData();
  }, []);

  if (sessionInfo?.username && sessionInfo.username === username)
    history.push(sessionInfo.url);

  return (
    <div>
      <div className={`account-setup${!username ? ' page-load' : ''}`}>
        <section className="Landing account-setup_image__container w-100 text-center">
          <img
            className="account-setup_image"
            src={AccountSetUpHero}
            alt="Landing Hero"
          />
        </section>
        <header>Welcome, {firstName}!</header>
        <p className="account-setup_content">
          Let’s set up your account. Take a minute to answer a few questions so
          we can populate your account in all the right places to help get you
          up and running.
        </p>
        <section className="account-setup-back">
          <button
            className="account-setup-back_button"
            onClick={() => history.push('/app/v2/account-setup/step/1')}
          >
            LET’S GET STARTED
          </button>
        </section>
        {!username && (
          <section className="app_loader">
            <FadeLoader
              color={styledTheme.lighterGray}
              loading={!username}
              height={15}
              width={5}
              radius={5}
              margin={2}
            />
          </section>
        )}
      </div>
    </div>
  );
};

export default AccountSetupStarted;
